var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack406({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.52,6.84,9.06,7a1.07,1.07,0,0,0-.28-.67.81.81,0,0,0-.58-.21,1,1,0,0,0-.81.43A3.61,3.61,0,0,0,7,8.34a1.75,1.75,0,0,1,1.4-.67A2.14,2.14,0,0,1,10,8.39a2.61,2.61,0,0,1,.68,1.86A2.69,2.69,0,0,1,10,12.19a2.45,2.45,0,0,1-1.82.73,2.42,2.42,0,0,1-2-.93,4.72,4.72,0,0,1-.77-3,4.83,4.83,0,0,1,.8-3.12,2.6,2.6,0,0,1,2.08-1,2.16,2.16,0,0,1,1.48.5A2.31,2.31,0,0,1,10.52,6.84ZM7.1,10.13a1.71,1.71,0,0,0,.34,1.14,1,1,0,0,0,.77.4.89.89,0,0,0,.7-.33,1.65,1.65,0,0,0,.28-1.08,1.72,1.72,0,0,0-.3-1.12.94.94,0,0,0-.75-.36,1,1,0,0,0-.74.34A1.5,1.5,0,0,0,7.1,10.13Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack406);
export default __webpack_public_path__ + "static/media/Symbolpack_4_06.30c8d5200305971d7b1c4d7bec8b63fa.svg";
export { ForwardRef as ReactComponent };